import { afterNextRender, ChangeDetectorRef, Component, Inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { FireBaseService } from './services/firebase.service';
import { AuthService } from './services/auth.service';
import { environment } from '../environments/environment';
import { ActivatedRoute, ActivationEnd, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Meta } from '@angular/platform-browser';
import { AlertService } from './services/alert.service';
import { debounceTime, filter, finalize, fromEvent, interval, Subject, takeUntil, throttleTime, timer } from 'rxjs';
import { SocketService } from '@service/socket.service';
import { Event } from '../app/client-socket-enum';
import { CurrentPage } from './constant/currentPage.interface';
import { MixPanelService } from '@service/mix-panel.service';
import { FireAnalyticsService } from '@service/fire-analytics.service';
import { MetaDataService } from '@service/meta-data.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { DialogService } from '@service/dialog.service';
import { TradingService } from './trading/trading.service';
import { DOCUMENT } from '@angular/common';
import { FacebookService } from '@service/facebook.service';
import { RouterAnimation } from './Animations/route.animation';

declare let cordova: any;
declare let navigator: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [RouterAnimation,
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(500, style({ opacity: 1 }))
      ]),
      transition('* => void', [
        animate(300, style({ opacity: 0 }))
      ])
    ])
  ]
})
export class AppComponent implements OnInit, OnDestroy {

  script: any;
  isIos: boolean = environment.ios;
  isApp: boolean = environment.app;
  unSubscribe: Subject<any> = new Subject()
  unSubscribeSockets: Subject<any>;
  currentUser: any;
  ongoinSockets: Event[] = []
  backCount: number = 0;
  currentPage: CurrentPage = {
    route: '/',
    displayName: '',
    isHelp: false,
    showBackBtn: true
  }
  showPickright: boolean = this.isApp ? false : true
  appLoadingTimer: number = 1
  appSplashTimer: number = 1000
  loadPickright: boolean = false
  intervalTimer: Subject<any> = new Subject();
  isSignUpOffer: boolean = false
  currentRouteIndex: any = 0;
  isAppLoading: boolean = true
  routeAnnouncement: string = '';
  constructor(
    private firebaseService: FireBaseService,
    private authService: AuthService,
    private router: Router,
    private dialogService: DialogService,
    private meta: Meta,
    private alertService: AlertService,
    private socketService: SocketService,
    private _ngZone: NgZone,
    private mixPanelService: MixPanelService,
    private analytics: FireAnalyticsService,
    private metaService: MetaDataService,
    private actvdRoute: ActivatedRoute,
    private tradingService: TradingService,
    @Inject(DOCUMENT) private document: Document,
    private fbService: FacebookService,
    private cd: ChangeDetectorRef
  ) {
    if (this.isIos) {
      this.meta.updateTag({ name: 'viewport', content: 'width=device-width, initial-scale=1, height=device-height, viewport-fit=cover' });
      const htmlBody = this.document.getElementsByTagName('body').item(0);
      htmlBody.style.paddingTop = 'constant(safe-area-inset-top)';
      htmlBody.style.paddingTop = 'env(safe-area-inset-top)';
    }
    this.metaService.setSEOIndex(environment.production)
    if (this.isApp) {
      this.showPickright = false
      this.document.addEventListener('deviceready', this.onDeviceReady, false);
    } else {
      afterNextRender(() => {
        this.authService.checkAuth(false, true);
        this.metaService.addGooleTagmanager()
        this.fbService.initFb()
        this.appInitializers()
      });
    }
  }

  ngOnInit() {
    this.getClientDetails()
    this.onWindowResize()
  }

  appInitializers() {
    this.routerDataFeed()
    this.authService.isLoggedIn.pipe(takeUntil(this.unSubscribe)).subscribe((res) => {
      if (res) {
        this.unSubscribeSockets = new Subject()
        if (!this.socketService.feedSocket || this.socketService.feedSocket.disconnected) {
          this.socketService.connectFeedSocket()
        }
        if (!this.socketService.webSocket || this.socketService.webSocket.disconnected) {
          this.socketService.initSocket()
        }
        timer(500).subscribe((res) => {
          if (this.socketService.webSocket && this.socketService.webSocket.connected) {
            this.initGlobalSocketEvents();
          }
        })
      } else {
        timer(500).subscribe((res) => {
          if (this.socketService.webSocket || (this.socketService.webSocket && !this.socketService.webSocket.disconnected)) {
            if (this.unSubscribeSockets && !this.unSubscribeSockets.observed) {
              this.unSubscribeSockets.next(null);
              this.unSubscribeSockets.complete();
            }
          }
        })
      }
    })
    this.authService.userProfile.pipe(takeUntil(this.unSubscribe)).subscribe((res) => {
      this.currentUser = res
      if (this.currentUser) {
        timer(500).subscribe((res) => {
          if (typeof window !== 'undefined' && window.localStorage.getItem('validOffer')) {
            this.isSignUpOffer = true
          }
        })
      }
    })

    this.authService.isShowOfferPopup().pipe(takeUntil(this.unSubscribe)).subscribe((res) => {
      if (res && typeof window !== 'undefined') {
        const offerBenefits = this.currentUser.rewardBenefits.benefitsReceived
        if (!window.localStorage.getItem('offerSeen') && !this.currentUser.couponCode && !this.currentUser.referredCode && (!offerBenefits.adminOfferRiskProfiling || !offerBenefits.adminOfferPaidSubscription)) {
          this.checkSignUpOffer()
        } else if (window.localStorage.getItem('isNewSignup')) {
          this.getReferralRewards()
        } else if (window.localStorage.getItem('referralLogin')) {
          this.dialogService.openReferralRewardDialog({}, {
            page: 'noReward',
            currentRewards: [],
            availableRewards: []
          })
          window.localStorage.removeItem('referralLogin')
        } else if (window.localStorage.getItem('couponLogin')) {
          this.getCouponReward(window.localStorage.getItem('couponLogin'))
        } else if (window.localStorage.getItem('noCouponLogin')) {
          window.localStorage.removeItem('noCouponLogin')
          this.dialogService.openCouponRewardDialog({}, { noReward: true })
        }
      }
    })
    this.firebaseService.calculateDeviceDetail();
    this.firebaseService.deviceDetail.subscribe((res: any) => {
      // if (res && !(res.os === 'Android' || res.os === 'iOS')) {
      if (res) {
        this.firebaseService.getPermission();
      }
    });
    this.checkIsMobileDevice();
    this.mixPanelService.initializeMixPanel()
    this.analytics.setFirebaseUserProperties();
    this.initFlow()
  }

  getBrokerageHouses() {
    return new Promise((resolve, rejct) => {
      this.authService.getBrokerageHouses()
        .pipe(finalize(() => resolve(true)), takeUntil(this.unSubscribe))
        .subscribe((res: any) => {
          const allBroker: any[] = res.data
          this.alertService.setBrokerageHouses(allBroker.filter((x) => x.isActive));
        })
    })
  }

  ngOnDestroy(): void {
    this.unSubscribe.next(null)
    this.unSubscribe.complete()
    if (typeof window !== 'undefined') {
      window.sessionStorage.removeItem('campaign')
    }
  }

  // @HostListener('window:resize', [])
  onWindowResize() {
    if (typeof window !== 'undefined') {
      fromEvent(window, 'resize').pipe(debounceTime(10)).subscribe((res) => {
        timer(100).subscribe((res) => {
          this.checkIsMobileDevice();
        })
      })
    }
  }

  checkIsMobileDevice() {
    if (typeof window !== 'undefined') {
      const isMobile = window.matchMedia('only screen and (max-width: 760px)').matches;
      this.alertService.setIsMobileDevice(isMobile);
    }
    // if (isMobile) {
    //   this.alertService.removeWhatsAppWidget();
    // } else {
    //   this.alertService.addWhatsAppWidget();
    // }
  }

  onDeviceReady = () => {
    if (typeof window !== 'undefined') {
      (window.navigator as any).splashscreen.hide();
      if (window && (window as any).FirebasePlugin) {
        (window as any).FirebasePlugin.getToken(
          (fcmToken: any) => {
            this.authService.setDeviceToken(fcmToken);
            this.getMessages();
          },
          err => {
            console.log('Device Token Error:: ', err);
          }
        );

        // Setting Up Channel
        const channel = {
          id: 'fcm_default_channel',
          name: 'Default',
          description: '',
          sound: 'default',
          vibration: true,
          light: true,
          lightColor: -1,
          importance: 4,
          badge: true,
          visibility: 1
        };
        (window as any).FirebasePlugin.createChannel(
          channel,
          () => {
            // alert("Default channel set");
          },
          (err: any) => {
            console.error(err);
            // alert(JSON.stringify(err));
          }
        );
      }
    }
    if (this.isApp) {
      interval().pipe(takeUntil(this.intervalTimer)).subscribe(() => {
        this.appLoadingTimer++
        if (this.appLoadingTimer >= this.appSplashTimer) {
          this.loadPickright = true
          if (this.intervalTimer) {
            this.intervalTimer.next(null)
            this.intervalTimer.complete()
          }
        }
      })
      if (this.appLoadingTimer >= this.appSplashTimer) {
        this.loadPickright = true
        if (this.intervalTimer) {
          this.intervalTimer.next(null)
          this.intervalTimer.complete()
        }
      }
    }
  }

  getMessages = () => {
    if (!this.isApp) {
      if (typeof window !== 'undefined') {
        (window as any).FirebasePlugin.onMessageReceived(
          (message: any) => {
            if (message && message.tap === 'background') {
              timer(100).subscribe((res) => {
                this.dialogService.closeAll();
                this.router.navigate([message.link]);
              })
            }
          });
      }
    }
  }

  initGlobalSocketEvents() {
    if (!this.socketService.checkIfAlredyConnected(Event.NOTIFICATION_EVENT)) {
      this.ongoinSockets.push(Event.NOTIFICATION_EVENT)
      this.socketService
        .onEvent(Event.NOTIFICATION_EVENT)
        .pipe(takeUntil(this.unSubscribeSockets))
        .subscribe((res: any) => {
          if (res && res.users.indexOf(this.currentUser.id) > -1) {
            this.alertService.setNotification()
          }
        });
    }
  }

  getGlobalVideos() {
    return new Promise((resolve, rejct) => {
      this.authService.getGlobalVideos()
        .pipe(finalize(() => resolve(true)), takeUntil(this.unSubscribe))
        .subscribe((res) => {
          this.alertService.setGlobalVideo(res || {})
        })
    })
  }

  handleDynamicLink() {
    timer(500).subscribe((res) => {
      cordova.plugins.firebase.dynamiclinks.onDynamicLink((data) => {
        if (data && data.deepLink) {
          this._ngZone.runOutsideAngular(() => {
            this._ngZone.run(() => {
              let url;
              if (data.deepLink.indexOf(environment.webUrl) > -1) {
                url = environment.webUrl
              } else if (data.deepLink.indexOf(environment.APIBaseUrl) > -1) {
                url = environment.APIBaseUrl
              } else {
                url = 'https://pickright.in';
              }
              let route: string = data.deepLink.replace(url, '');
              if (route.charAt(0) === '/', route.charAt(1) === '/') {
                route = route.substring(1, route.length)
              }
              this.dialogService.closeAll();
              if (route.indexOf('?') > -1) {
                this.router.navigateByUrl(route);
              } else {
                this.router.navigate([route]);
              }
            });
          });
        }
      });
    })
  }

  checkIfDynamicURl() {
    cordova.plugins.firebase.dynamiclinks.getDynamicLink().then((data) => {
      if (data && data.deepLink) {
        this._ngZone.runOutsideAngular(() => {
          this._ngZone.run(() => {
            let url;
            if (data.deepLink.indexOf(environment.webUrl) > -1) {
              url = environment.webUrl
            } else if (data.deepLink.indexOf(environment.APIBaseUrl) > -1) {
              url = environment.APIBaseUrl
            } else {
              url = 'https://pickright.in';
            }
            let route: string = data.deepLink.replace(url, '');
            if (route.charAt(0) === '/', route.charAt(1) === '/') {
              route = route.substring(1, route.length)
            }
            this.dialogService.closeAll();
            if (route.indexOf('?') > -1) {
              this.router.navigateByUrl(route);
            } else {
              this.router.navigate([route]);
            }
          });
        });
      }
    });
  }

  async initFlow() {
    await this.getUserVerticals()
    await this.getBrokerageHouses()
    if (this.isApp) {
      this.document.addEventListener('backbutton', (e) => {
        if (this.document.getElementById('homePage')) {
          e.preventDefault();
          this.backCount += 1;
          timer(5000).subscribe((res) => {
            this.backCount = 0;
          })
          this.backCount === 2 ? navigator.app.exitApp() : '';
        } else {
          navigator.app.backHistory();
        }
      });
    }
    await this.getGlobalVideos()
    await this.setMFImagesList()
    this.isAppLoading = false;
    this.cd.detectChanges();
  }

  checkAppVersion() {
    this.authService.getAppVersion(this.isIos ? 'IOS' : 'ANDROID').subscribe({
      next: (res) => {
        if (res.data && res.data.tag !== environment.appVersion) {
          this.alertService.setAppUpdate(res.data)
        }
        timer(1000).subscribe((res) => {
          this.showPickright = true
          this.authService.checkAuth(false, true);
          this.metaService.addGooleTagmanager()
          this.fbService.initFb()
          this.appInitializers()
        })
      },
      error: () => {
        timer(1000).subscribe((res) => {
          this.showPickright = true
          this.authService.checkAuth(false, true);
          this.metaService.addGooleTagmanager()
          this.fbService.initFb()
          this.appInitializers()
        })
      }
    });
  }

  setMFImagesList() {
    return new Promise((resolve, rejct) => {
      this.authService.getAllMFImages()
        .pipe(finalize(() => resolve(true)), takeUntil(this.unSubscribe))
        .subscribe((res) => {
          this.alertService.setMutualFundImages(res.data)
        })
    })
  }

  getUserVerticals() {
    return new Promise((resolve, rejct) => {
      this.authService.getVerticals()
        .pipe(finalize(() => resolve(true)), takeUntil(this.unSubscribe))
        .subscribe((res: any) => {
          this.alertService.setVerticals(res.data.investor);
        })
    })
  }

  routerDataFeed() {
    this.router.events.pipe(
      filter((x) => x instanceof NavigationEnd)
    ).subscribe({
      next: (event: NavigationEnd) => {
        if (event) {
          setTimeout(() => {
            const title = this.currentPage?.displayName || document.title || 'Page loaded';
            this.routeAnnouncement = '';
            setTimeout(() => {
              this.routeAnnouncement = `Navigated to ${title}`;
            }, 50);
          }, 100);
          let url = event.url
          if (url.indexOf('?') > -1) {
            url = url.slice(0, url.indexOf('?'))
          }
          this.currentPage.route = url;
          this.alertService.setCurrentPage(this.currentPage)
          if (typeof document !== 'undefined') {
            this.metaService.setRoute(`${environment.webUrl}${url}`)
            document.getElementsByClassName("layout_wrap")[0]?.scroll({ top: 0 })
          }
        }
      }
    });


    this.router.events.pipe(
      filter((x) => x instanceof ActivationEnd),
      throttleTime(0)
    ).subscribe((event: ActivationEnd) => {
      if (event) {
        this.currentPage.displayName = event.snapshot.data.PageName
        if (event.snapshot.data.showBackBtn || event.snapshot.data.showBackBtn === false) {
          this.currentPage.showBackBtn = event.snapshot.data.showBackBtn
        }
        this.alertService.setCurrentPage(this.currentPage)
        if (event.snapshot.data.metaTitle) {
          this.metaService.setTitle(event.snapshot.data.metaTitle)
        }
        if (event.snapshot.data.metaDesc) {
          this.metaService.setMetaDesc(event.snapshot.data.metaDesc)
        }
        if (event.snapshot.data.metaKeywords) {
          this.metaService.setMetaKeywords(event.snapshot.data.metaKeywords)
        }
      }
    })

    this.actvdRoute.queryParams.pipe(takeUntil(this.unSubscribe)).subscribe((res) => {
      if (res && res.campaignName) {
        if (typeof window !== 'undefined') {
          if (!window.sessionStorage.getItem('campaign')) {
            this.authService.campaignVisitor(res.campaignName)
            window.sessionStorage.setItem('campaign', res.campaignName)
          } else if (window.sessionStorage.getItem('campaign') !== res.campaignName) {
            this.authService.campaignVisitor(res.campaignName)
            window.sessionStorage.setItem('campaign', res.campaignName)
          }
        }
      }
    })
  }

  splashComplete(event) {
    timer(100).subscribe((res) => {
      if (typeof window !== 'undefined') {
        (window as any).handleOpenURL = (link) => {
          if (link) { this.handleDynamicLink(); }
        };
      }
      this.handleDynamicLink();
      this.checkIfDynamicURl()
    })
    this.checkAppVersion()
  }

  getReferralRewards() {
    this.authService.getReferralDetails().pipe(takeUntil(this.unSubscribe)).subscribe((res) => {
      this.dialogService.openReferralRewardDialog({}, {
        page: 'product',
        currentRewards: res.data,
        availableRewards: []
      })
      if (typeof window !== 'undefined') {
        window.localStorage.removeItem('isNewSignup')
      }
    })
  }

  checkSignUpOffer() {
    this.authService.checkUserOffers().pipe(takeUntil(this.unSubscribe)).subscribe((res) => {
      if (res.data && res.data.length) {
        if (this.isSignUpOffer) {
          let signupOffer = res.data.find((x: any) => x.activity === 'admin_offers_signup')
          if (signupOffer && this.currentUser.rewardBenefits.benefitsReceived.adminOfferSignup) {
            this.dialogService.openOfferRewardDialog({}, {
              page: 'product',
              currentRewards: signupOffer,
              availableRewards: []
            })
          } else {
            this.pendingOffer(res.data)
          }
        } else {
          this.pendingOffer(res.data)
        }
      }
      if (typeof window !== 'undefined') {
        window.localStorage.setItem('offerSeen', 'true')
        window.localStorage.removeItem('validOffer')
      }
    })
  }

  pendingOffer(currentOffers) {
    this.authService.checkUserSubscriptions().subscribe((res) => {
      let availOffers: any[] = []
      if (!this.currentUser.rewardBenefits.benefitsReceived.adminOfferRiskProfiling && !this.currentUser.riskProfile) {
        let rpOffer = currentOffers.find((x: any) => x.activity === 'admin_offers_riskProfiling')
        if (rpOffer) {
          availOffers.push(rpOffer)
        }
      }

      if (!this.currentUser.rewardBenefits.benefitsReceived.adminOfferPaidSubscription && !res.isPaidPackSubscriptionExist) {
        let subOffer = currentOffers.find((x: any) => x.activity === 'admin_offers_paid_subscription')
        if (subOffer) {
          availOffers.push(subOffer)
        }
      }
      if (availOffers.length) {
        this.dialogService.openOfferRewardDialog({}, {
          page: 'product',
          currentRewards: null,
          availableRewards: availOffers
        })
      }
    })
  }

  getCouponReward(code) {
    this.authService.getCouponSignupReward().subscribe((res) => {
      if (res && res.data && res.data.couponCode === code) {
        this.dialogService.openCouponRewardDialog({}, { ...res.data, rewardGiven: true })
        if (typeof window !== 'undefined') {
          window.localStorage.removeItem('couponLogin')
        }
      }
    })
  }

  getClientDetails() {
    this.tradingService.getClientDetails().pipe(takeUntil(this.unSubscribe)).subscribe((res: any) => {
      if (res)
        this.authService.setClientToken(btoa(`${res.clientCode}:${res._id}`));
    })
  }
  onActivate(outlet: RouterOutlet) {
    this.currentRouteIndex = +(outlet?.activatedRouteData['routeIndex'] || -1);
  }
}
